module.exports = __webpack_public_path__ + "img/P4.2934626b.jpg";